import { BackgroundThemeRevision } from 'referral-types';
import ElectrifyingSlope from './subthemes/ElectrifyingSlope';
import GridPaper from './subthemes/GridPaper';
import HoverFadeDotsGrid from './subthemes/HoverFadeDotsGrid';
import SimpleGrid from './subthemes/SimpleGrid';

export const GRIDS_BACKGROUND_THEME_ID = 'e4c2f5d1-6b7a-4f3e-9d8c-2a1f5e7b9d0c';

enum SubThemes {
  Slope = 'slope',
  Dots = 'dots',
  Paper = 'paper',
  Simple = 'simple',
}

export const GridSubThemeOptions = [
  { value: SubThemes.Slope, label: 'Slope' },
  { value: SubThemes.Dots, label: 'Dots' },
  { value: SubThemes.Paper, label: 'Paper' },
  { value: SubThemes.Simple, label: 'Simple' },
];

export const GridBackgrounds = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  const subtheme = themeRevision?.subTheme || SubThemes.Dots;

  switch (subtheme as SubThemes) {
    case SubThemes.Slope:
      return <ElectrifyingSlope {...props} />;
    case SubThemes.Dots:
      return <HoverFadeDotsGrid {...props} />;
    case SubThemes.Paper:
      return <GridPaper {...props} />;
    case SubThemes.Simple:
      return <SimpleGrid {...props} />;
    default:
      return <HoverFadeDotsGrid {...props} />;
  }
};
